import React from 'react';
import { useHasRole } from '../hooks/useHasRole';
import { Role } from '../domain/Role';

interface RoleRenderProps {
  allowedRoles: Role[];
  children: React.ReactNode;
}

export const RoleValidator = ({ allowedRoles, children }: RoleRenderProps) => {
  const hasPermission = useHasRole(allowedRoles);

  return (<>
    {hasPermission && children}
  </>);
};
